/* AD IN A BOX — scales each CSS artboard (authored at 1080x1350) down to its tile. */
(function () {
  'use strict';
  if (window.__aibAdsLoaded) return; window.__aibAdsLoaded = true;

  var W = 1080, H = 1350;

  function fit(card) {
    var w = card.clientWidth, h = card.clientHeight;
    if (!w) return;
    // Cover the tile: square category crops need the larger of the two ratios.
    var s = Math.max(w / W, h / H);
    card.style.setProperty('--aib-adc-s', s);
    var inner = card.firstElementChild;
    if (inner) {
      // Centre the overflow so a square crop keeps the headline in frame.
      inner.style.left = Math.round((w - W * s) / 2) + 'px';
      inner.style.top = Math.round((h - H * s) / 2) + 'px';
    }
  }

  function init() {
    var cards = document.querySelectorAll('[data-aib-adc]');
    if (!cards.length) return;
    cards.forEach(fit);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (entries) { entries.forEach(function (e) { fit(e.target); }); });
      cards.forEach(function (c) { ro.observe(c); });
    } else {
      window.addEventListener('resize', function () { cards.forEach(fit); }, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
